import { Link } from "react-router-dom";
import StoryCard from "@/components/feature/StoryCard";
import type { Story } from "@/mocks/stories";

type FocusSectionProps = {
  lead: Story;
  ranking: Story[];
};

export default function FocusSection({ lead, ranking }: FocusSectionProps) {
  return (
    <section className="bg-background-50 py-8 md:py-12">
      <div className="mx-auto max-w-[1360px] px-4 md:px-6">
        <div className="mb-5 flex items-end justify-between gap-4 md:mb-7">
          <div className="flex items-center gap-3">
            <span className="block h-7 w-1.5 rounded-full bg-primary-500" aria-hidden="true" />
            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-3xl">
                今日聚焦
              </h2>
              <p className="mt-1 font-label text-xs text-foreground-500 md:text-sm">
                编辑部当前重点跟进的一条线索，逐步更新中
              </p>
            </div>
          </div>
          <Link
            to="/news"
            className="hidden shrink-0 items-center gap-1 whitespace-nowrap font-label text-sm text-foreground-700 transition-colors hover:text-primary-600 sm:flex"
          >
            全部追踪
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3 lg:gap-8">
          <div className="lg:col-span-2">
            <StoryCard story={lead} variant="lead" />
          </div>

          <aside className="rounded-lg border border-background-300 bg-background-100 p-4 md:p-5">
            <div className="mb-3 flex items-center justify-between border-b border-background-300 pb-3">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <span className="flex h-5 w-5 items-center justify-center">
                  <i className="ri-fire-line text-accent-600" />
                </span>
                热度追踪榜
              </h3>
              <span className="font-label text-xs text-foreground-500">实时更新</span>
            </div>
            <ul>
              {ranking.map((story, index) => (
                <StoryCard key={story.id} story={story} variant="compact" index={index} />
              ))}
            </ul>
            <Link
              to="/news?sort=heat"
              className="mt-4 flex items-center justify-center gap-1 whitespace-nowrap rounded-md border border-background-300 bg-background-50 py-2.5 font-label text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              查看完整榜单
              <i className="ri-arrow-right-line" />
            </Link>
          </aside>
        </div>
      </div>
    </section>
  );
}